import React from "react";
import { PageHeader } from "./PageHeader"
import { DataBox } from "./DataBox"
import { PoPrint } from "./PoPrint"
import { LogDrawer } from "./logDrawer";
export default () => {
    return (
        <>
            <PageHeader />
            <DataBox />
            <PoPrint />
            <LogDrawer />
        </>
    )
}